import { useCallback } from 'react';

import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

export default function useAddQueryParam(queryParamName, url) {
  const location = useLocation();
  const navigate = useNavigate();
  const [query] = useSearchParams();

  const currentQueryParam = query.get(queryParamName);

  const addQueryParam = useCallback(
    (key, value) => {
      // Create a URLSearchParams object from the current search string
      const searchParams = new URLSearchParams(location.search);

      // Set the new query parameter
      searchParams.set(key, value);

      // Remove the 'addNew' query parameter if it exists
      if (searchParams.has('addNew')) {
        searchParams.delete('addNew');
      }

      // Remove the 'addNewPrincipalPayment' query parameter if it exists
      if (searchParams.has('addNewPrincipalPayment')) {
        searchParams.delete('addNewPrincipalPayment');
      }

      // Remove addNewPayoffInvoice query parameter if it exists
      if (searchParams.has('addNewPayoffInvoice')) {
        searchParams.delete('addNewPayoffInvoice');
      }

      // Remove invoiceId query parameter if it exists
      if (searchParams.has('invoiceId')) {
        searchParams.delete('invoiceId');
      }

      // Navigate to the same route with the updated search string
      navigate(`${url || location.pathname}?${searchParams.toString()}`, {
        replace: true,
      });
    },
    [location, navigate, url]
  );

  return { addQueryParam, currentQueryParam };
}
